// @ts-nocheck
import React, { useState } from 'react';
import { useIntl } from 'react-intl';

import { useConfiguration } from '../../../../context/configurationContext';
import { useRouteConfiguration } from '../../../../context/routeConfigurationContext';
import appSettings from '../../../../config/settings';
import { pathByRouteName } from '../../../../util/routes';

import TopbarDesktopStyled from './TopbarDesktopStyled';

import '../../../../styles/tailwind.css';

interface TopbarStyledProps {
  isAuthenticated: boolean;
  currentUser: any;
  currentPage?: string;
  onLogout: (historyPush: any) => void;
  notificationCount: number;
  onManageDisableScrolling: (componentId: string, disableScrolling: boolean) => void;
  onResendVerificationEmail: () => void;
  sendVerificationEmailInProgress: boolean;
  sendVerificationEmailError: any;
  showGenericError: boolean;
  currentUserHasListings: boolean;
  currentUserHasOrders: boolean;
  isLoggedInAs: boolean;
  authScopes: string[];
  authInProgress: boolean;
  location: any;
  history: any;
}

const TopbarStyled: React.FC<TopbarStyledProps> = props => {
  const {
    isAuthenticated,
    currentUser,
    currentPage,
    onLogout,
    notificationCount,
    history,
    location,
    ...rest
  } = props;

  const config = useConfiguration();
  const routeConfiguration = useRouteConfiguration();
  const intl = useIntl();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    onLogout(history).then(() => {
      const path = pathByRouteName('LandingPage', routeConfiguration);
      if (appSettings.dev) {
        history.push(path);
      } else if (typeof window !== 'undefined') {
        window.location = path;
      }
    });
  };

  return (
    <TopbarDesktopStyled
      isAuthenticated={isAuthenticated}
      currentUser={currentUser}
      currentPage={currentPage || ''}
      onLogout={handleLogout}
      notificationCount={notificationCount}
      config={config}
      routeConfiguration={routeConfiguration}
      intl={intl}
      history={history}
      mobileMenuOpen={mobileMenuOpen}
      setMobileMenuOpen={setMobileMenuOpen}
    />
  );
};

export default TopbarStyled;
